import { PageHeader } from "@/components/shared/PageHeader";
import { PartnersSection } from "@/components/home/PartnersSection";
import { PartnerCTA } from "@/components/home/PartnerCTA";

const IMG = "https://static.prod-images.emergentagent.com/jobs/19db1358-9c8e-4718-a041-5f96f8d9cb74/images/602da315b873c9920ffbe3f13141c12af23c36b38d3cc012c7ceb731f99a6591.jpeg";

export default function Partners() {
  return (
    <>
      <PageHeader kicker="Partners & Sponsorer" title="Partners" subtitle="Företagen som gör Novemberkåsan 2026 möjlig." image={IMG} />
      <PartnersSection full hideHeader />
      <PartnerCTA />
    </>
  );
}
